import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Quartier } from '@/core/interfaces/quartier.interface';

interface QuartierStateData {
  quartiers: Quartier[];
  currentPage: number;
  totalPages: number;
  loading: boolean;
  hasMore: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class QuartierState {
  private state = new BehaviorSubject<QuartierStateData>({
    quartiers: [],
    currentPage: 0,
    totalPages: 0,
    loading: false,
    hasMore: true,
  });

  public state$ = this.state.asObservable();

  getState(): QuartierStateData {
    return this.state.value;
  }

  setQuartiers(quartiers: Quartier[], page: number, totalPages: number): void {
    const currentState = this.state.value;
    this.state.next({
      ...currentState,
      quartiers: page === 0 ? quartiers : [...currentState.quartiers, ...quartiers],
      currentPage: page,
      totalPages,
      hasMore: page < totalPages - 1,
      loading: false,
    });
  }

  setLoading(loading: boolean): void {
    this.state.next({
      ...this.state.value,
      loading,
    });
  }

  reset(): void {
    this.state.next({
      quartiers: [],
      currentPage: 0,
      totalPages: 0,
      loading: false,
      hasMore: true,
    });
  }
}
